import { useCallback, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';

import { ncsvCreatorActions } from 'actions/modules/tools';

import HeaderStep from './HeaderStep';

import './Header.scss';

const STEPS = ncsvCreatorActions.STEPS
const Header = ({ activeStep, errorSteps, sucessSteps, setActiveStep, ref }) => {
  const onClickFirstStep = useCallback(() => setActiveStep(STEPS.DATE), [setActiveStep]),
        onClickSecondStep = useCallback(() => setActiveStep(STEPS.SYMBOLS), [setActiveStep]),
        onClickThirdStep = useCallback(() => setActiveStep(STEPS.COLUMNS), [setActiveStep]),
        onClickFourthStep = useCallback(() => setActiveStep(STEPS.VALIDATE), [setActiveStep])
  
  useImperativeHandle(ref, () => ({ 
    validateForForm: () => true,
    isValid: () => true
  }))
  return (
    <div className="ncsv-creator__top__header">
      <HeaderStep
          isActive={activeStep === STEPS.DATE}
          isError={errorSteps.includes(STEPS.DATE)}
          isSuccess={sucessSteps.includes(STEPS.DATE)}
          label={STEPS.DATE}
          number="1"
          onClick={onClickFirstStep}
      />
      <div className="ncsv-creator__top__header__dots">
        <div className="ncsv-creator__top__header__dots__dot"/>
        <div className="ncsv-creator__top__header__dots__dot"/>
        <div className="ncsv-creator__top__header__dots__dot"/>
      </div>
      <HeaderStep
          isActive={activeStep === STEPS.SYMBOLS}
          isDisabled={activeStep !== STEPS.DATE}
          isError={errorSteps.includes(STEPS.SYMBOLS)}
          isSuccess={sucessSteps.includes(STEPS.SYMBOLS)}
          label={STEPS.SYMBOLS}
          number="2"
          onClick={onClickSecondStep}
      />
      <div className="ncsv-creator__top__header__dots">
        <div className="ncsv-creator__top__header__dots__dot"/>
        <div className="ncsv-creator__top__header__dots__dot"/>
        <div className="ncsv-creator__top__header__dots__dot"/>
      </div>
      <HeaderStep
          isActive={activeStep === STEPS.COLUMNS}
          isDisabled={activeStep !== STEPS.SYMBOLS}
          isError={errorSteps.includes(STEPS.COLUMNS)}
          isSuccess={sucessSteps.includes(STEPS.COLUMNS)}
          label={STEPS.COLUMNS}
          number="3"
          onClick={onClickThirdStep}
      />
      <div className="ncsv-creator__top__header__dots">
        <div className="ncsv-creator__top__header__dots__dot"/>
        <div className="ncsv-creator__top__header__dots__dot"/>
        <div className="ncsv-creator__top__header__dots__dot"/>
      </div>
      <HeaderStep
          isActive={activeStep === STEPS.VALIDATE}
          isDisabled={activeStep !== STEPS.COLUMNS}
          isError={errorSteps.includes(STEPS.VALIDATE)}
          isSuccess={sucessSteps.includes(STEPS.VALIDATE)}
          label={STEPS.VALIDATE}
          number="4"
          onClick={onClickFourthStep}
      />
    </div>
  )
}

Header.displayName = "Header"

Header.propTypes = {
  activeStep: PropTypes.string.isRequired,
  errorSteps: PropTypes.array.isRequired,
  setActiveStep: PropTypes.func.isRequired,
  sucessSteps: PropTypes.array.isRequired,
}

export default Header